document.addEventListener('DOMContentLoaded', function () {
  if (typeof MicroModal === 'undefined') return;

  MicroModal.init({
    openTrigger: 'data-micromodal-trigger',
    closeTrigger: 'data-micromodal-close',
    disableScroll: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
  });
});
